import { type RouteRecordRaw } from 'vue-router'

export const salesRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/SalesDashboardView.vue'),
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
      title: 'sales.dashboard',
    },
    name: 'brand.sales',
    path: 'sales',
  },
]
